import React from 'react';
import './ConfirmDialog.css';

/** Branded confirm modal — use instead of window.confirm. */
const ConfirmDialog = ({ title, body, confirmLabel = 'Confirm', danger = false, busy = false, onConfirm, onCancel }) => (
  <div className="confirm-dialog-overlay" onClick={busy ? undefined : onCancel}>
    <div className="confirm-dialog" role="dialog" aria-modal="true" aria-labelledby="confirm-dialog-title"
      onClick={(e) => e.stopPropagation()}>
      <h3 id="confirm-dialog-title" className="confirm-dialog-title">{title}</h3>
      {body && <p className="confirm-dialog-body">{body}</p>}
      <div className="confirm-dialog-actions">
        <button type="button" className="confirm-dialog-btn" onClick={onCancel} disabled={busy}>Cancel</button>
        <button
          type="button"
          className={`confirm-dialog-btn ${danger ? 'is-danger' : 'is-primary'}`}
          onClick={onConfirm}
          disabled={busy}
        >
          {busy ? 'Please wait…' : confirmLabel}
        </button>
      </div>
    </div>
  </div>
);

export default ConfirmDialog;
